import { Injectable } from '@angular/core';

function _window(): any {
  return window;
}

function _document(): any {
  return document;
}

@Injectable()
export class WindowRef {
  get window(): any {
    return _window();
  }
}

@Injectable()
export class DocumentRef {
  get document(): any {
    return _document();
  }
}
